var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 26,
    viewBox: "0 0 13 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40021 26V12.1786H0V8.55338H2.40021V7.47712C2.40021 5.94771 2.62349 4.64488 3.12586 3.51198C3.62823 2.37908 4.29805 1.52941 5.24697 0.906318C6.14007 0.283224 7.20063 0 8.42865 0C9.21011 0 9.93576 0.11329 10.7172 0.283224C11.4429 0.453159 12.2243 0.736383 12.8942 1.07625L12.0011 4.64488C11.6661 4.4183 11.2196 4.24837 10.773 4.19172C10.3265 4.07843 9.87994 4.02179 9.48921 4.02179C8.70774 4.02179 8.09373 4.30501 7.64718 4.87146C7.25645 5.43791 7.03318 6.23094 7.03318 7.30719V8.55338H11.4429V12.1786H7.03318V26H2.40021Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.daf135e4d11cbb904408ef7fcd369851.svg";
export { ForwardRef as ReactComponent };